<script setup>
import VariableInput from './VariableInput.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['delete']);

const model = defineModel({ required: true });

const updateKey = key => {
  model.value = { ...model.value, key };
};

const updateValue = value => {
  model.value = { ...model.value, value };
};

const handleDelete = () => {
  emit('delete');
};
</script>

<template>
  <div class="flex gap-2 items-start mb-2">
    <input
      :value="model.key"
      type="text"
      class="answer--text-input flex-1"
      :placeholder="
        $t('AUTOMATION.ACTION.ADVANCED_WEBHOOK.HEADER_KEY_PLACEHOLDER')
      "
      @input="updateKey($event.target.value)"
    />
    <div class="flex-1">
      <VariableInput
        :model-value="model.value"
        :placeholder="
          $t('AUTOMATION.ACTION.ADVANCED_WEBHOOK.HEADER_VALUE_PLACEHOLDER')
        "
        @update:model-value="updateValue"
      />
    </div>
    <NextButton
      icon="i-lucide-trash-2"
      sm
      faded
      ruby
      class="flex-shrink-0"
      @click="handleDelete"
    />
  </div>
</template>
